function SharedMomentsFactory($http, config) {
    const {
        baseUrl
    } = config

    let posts = []

    const addPosts = (newPosts) => {
        posts = posts.concat(newPosts)

        posts = posts.filter((obj, index, self) => self.findIndex(item => item.id === obj.id) === index)
    }

    const unshiftPost = (newPost) => {
        if (posts.findIndex(item => item.id === newPost.id)) {
            posts.unshift(newPost)
        }
    }

    const setPosts = (newPosts) => {
        posts = newPosts
    }

    const getLoadedPosts = () => posts

    const getPost = (postId) => {
        return $http.get(`${baseUrl}/api/posts/${postId}`)
    }

    const getPosts = (categories = [], urls = []) => {
        return $http.post(`${baseUrl}/api/posts`, {
            categories,
            urls
        })
    }

    const searchPosts = (word, urls, postId) => {
        const searchWord = encodeURIComponent(word)

        return $http.post(`${baseUrl}/api/posts/search?text=${searchWord}`, {
            urls,
            postId
        })
    }

    const checkContributor = (username) => {
        return $http.get(`${baseUrl}/api/posts/contributor/${username}`)
    }

    const thumbPost = (url, type) => {
        return $http.put(`${baseUrl}/api/posts/thumb`, {
            url,
            type
        })
    }

    const getCertificate = (username) => {
        return $http.get(`${baseUrl}/api/certificates/${username}`)
    }

    return {
        addPosts,
        unshiftPost,
        setPosts,
        getLoadedPosts,
        getPost,
        getPosts,
        searchPosts,
        checkContributor,
        thumbPost,
        getCertificate
    }
}

SharedMomentsFactory.$inject = ['$http', 'config']

export default SharedMomentsFactory



// WEBPACK FOOTER //
// ./client/app/components/home/sharedmoments/sharedmoments.factory.js